import { Row } from "antd";
import classes from "../Pages.module.css";
import DataField from "./DataField";
import { useState,  useContext } from "react";
import axios from "axios";
import DataContext from "../../../Context/dataContext";
// import { Select} from "antd";

// const { Option } = Select;
const BasicDetail = (props) => {
  console.log(props, "prrrrrrrrrrrrrrrrrrrrrrrrrrrr");
  const [customers, setCustomers] = useState([]);
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [uom, setUom] = useState([]);

  const employeeData = useContext(DataContext);
  // const [unit, setUnit] = useState("kg"); // Default unit is 'kg'

  const handleChange = (e, param) => {
    props.setData((data) => {
      const newdata = [...data["SaudatHeader"]];
      newdata[0][param] = e.target.value;
      //  // console.log(newdata);
      return {
        ...data,
        SaudatHeader: newdata,
      };
    });
  };

  // const handleChange1 = (e, param) => {
  //   props.setData((data) => {
  //     const newdata = [...data["SaudatHeader"]];
  //     newdata[0][param] = e.target.value;
  //     //  // console.log(newdata);
  //     return {
  //       ...data,
  //       SaudatHeader: newdata,
  //     };
  //   });
  // };

  const handleSChange = (val, param) => {
    // props.setData((data) => {
    //   const newdata = [...data["SaudatHeader"]];

    //   newdata[0][param] = val;
    //   return {
    //     ...data,
    //     SaudatHeader: newdata,
    //   };
    // });

    props.setData((data) => {
      // Create a new copy of salesOrder to avoid mutating the state directly
      const newdata = [...data["SaudatHeader"]];

      if (param === "dealer_code") {
        // console.log(data, "data when dealer selected");
        props.setEditcustomer(false);
        // Clear previous values when a new dealer is selected
        newdata[0].cust_code = null; // Reset distributor code
        setCustomers(null); // Reset customers to null

        // Make API call to fetch customer list based on dealer code
        axios
          .get(
            employeeData.URL +
              "/api/v1/salesInvoice/additional-data-of-customer/" +
              val,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            console.log(response);
            const customer = response.data.data.customer.rows;
            const customersList = response.data.data.customer.rows; // Replace with the actual response structure
            setCustomers(customer);
            if (customersList.length > 0) {
              newdata[0].cust_code = customersList[0].cust_code; // Auto-fill first customer
            }
          })
          .catch((error) => {
            console.error("Error fetching customer list:", error);
          });
      }

      if (param === "item_cat_code") {
        // Reset delivery site code when a new distributor code is selected
        props.setEdititem(false);
        newdata[0].item_code = null; // Reset delivery site code
        newdata[0].uom_code = null;
        newdata[0].sauda_quality = null;
        setItems(null); // Reset address or other related fields

        // console.log(props);

        axios
          .get(
            employeeData.URL +
              "/api/v1/salesOrder/additional-data-of-customer/" +
              val,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            // console.log(response);
            const add = response.data.data.item.rows; // Replace with the actual response structure

            setItems(add); // Update state with the new address or details
          })
          .catch((error) => {
            console.error("Error fetching customer detail:", error);
          });
      }

      if (param === "item_code") {
        console.log("hi");
        // Reset delivery site code when a new distributor code is selected
        props.setEditgrade(false);
        props.setEdituom(false);
        // console.log(props.editMode);
        // if (props.editMode &&!props.editMode1) {
        //   setItems(props.items); // Set the items if editMode1 is false
        // }
        // setItems(props.items);
        newdata[0].sauda_quality = null; // Reset delivery site code
        newdata[0].uom_code = null;
        setCats(null); // Reset address or other related fields
        setUom(null);
        // // console.log(props);

        axios
          .get(
            employeeData.URL +
              "/api/v1/salesOrder/additional-data-of-item-cat/" +
              val,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            console.log(response);
            const add = response.data.data.item.rows; // Replace with the actual response structure
            setCats(add);
            setUom(response.data.data.uom.rows); // Update state with the new address or details

            newdata[0].uom_code = response.data.data.uom.rows[0].item_uom;
          })
          .catch((error) => {
            console.error("Error fetching customer detail:", error);
          });
      }

      // Update the salesOrder object with the new parameter value
      newdata[0][param] = val;

      // Return the updated state
      return {
        ...data,
        SaudatHeader: newdata,
      };
    });
  };

  
  const handleDChange = (date, dateString, param) => {
    props.setData((data) => {
      const newdata = [...data["SaudatHeader"]];
      newdata[0][param] = dateString;
      return {
        ...data,
        SaudatHeader: newdata,
      };
    });
  };

  return (
    <div>
      <p></p>
      <Row className={props.editMode ? classes["RowDEX"] : classes["RowD"]}>
        {!props.create && (
          <DataField
            editMode={props.editMode}
            lg={12}
            md={24}
            handleChange={handleChange}
            name="SAUDA CODE"
            param="sauda_code"
            value={props.data.sauda_code}
          />
        )}
        {/* <DataField editMode = {props.editMode} lg = {12} md = {24} handleChange = {handleChange} name = "ACCOUNT NAME" param = "account_name" value = {props.data.account_name}/>    */}
        <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleDChange}
          name="CONTRACT DATE"
          type="Date"
          param="sauda_date"
          required="True"
          value={props.data.sauda_date}
        />

        <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleSChange}
          options={props.ad.DEALER_CODE}
          type="Select"
          name="DEALER"
          param="dealer_code"
          required="True"
          value={props.data.dealer_code}
        />
        <DataField
          editMode={props.editMode}
          editcustomer={props.editcustomer}
          lg={8}
          md={24}
          handleChange={handleSChange}
          type="Select"
          name="CUSTOMER"
          param="cust_code"
          value={props.data.cust_code}
          required="True"
          customers={props.editcustomer ? props.customers : customers}
        />
        <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleSChange}
          options={props.ad.ITEM_CAT_CODE}
          type="Select"
          name="ITEM CATEGORY"
          param="item_cat_code"
          required="True"
          value={props.data.item_cat_code}
        />
        <DataField
          editMode={props.editMode}
          editMode1={props.editMode1}
          lg={8}
          md={24}
          handleChange={handleSChange}
          type="Select"
          name="ITEM"
          param="item_code"
          value={props.data.item_code}
          required="True"
          items={props.edititem ? props.items : items}
        />
        <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleSChange}
          type="Select"
          name="GRADE"
          param="sauda_quality"
          value={props.data.sauda_quality}
          required="True"
          cats={props.editgarde ? props.cats : cats}
        />
        <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleChange}
          name="CONTRACT QTY"
          param="sauda_qty"
          type="Input"
          required="True"
          value={props.data.sauda_qty}
        />

        {/* <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleChange}
          name="CONTRACT RATE"
          param="sauda_rate"
          type="Input"
          required="True"
          value={props.data.sauda_rate}
        /> */}

        {/* <div style={{ display: "flex", alignItems: "center", color: "red" }}> */}
        {/* CONTRACT RATE Input */}
        <DataField
          editMode={props.editMode}
          lg={6}
          md={24}
          handleChange={handleChange}
          name="CONTRACT RATE"
          param="sauda_rate"
          type="Input"
          required="True"
          value={props.data.sauda_rate}
        />

        {/* Unit Selection */}
        {/* <Select
            value={unit}
            onChange={handleUnitChange}
            style={{ marginLeft: "10px", width: 120 }}
          >
            <Option value="kg">kg</Option>
            <Option value="ton">ton</Option>
          </Select> */}
        {/* </div> */}

        <DataField
          editMode={props.editMode}
          lg={2}
          md={24}
          handleChange={handleSChange}
          uom={props.edituom ? props.uom : uom}
          type="Select"
          name="unit"
          param="uom_code"
          required="True"
          value={props.data.uom_code}
        />

        <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleSChange}
          options={props.ad.FREIGHT_TYPE_CODE}
          type="Select"
          name="FREIGHT TYPE"
          param="freight_type_code"
          required="True"
          value={props.data.freight_type_code}
        />
        {/* <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleChange}
          name="ACTUAL QTY"
          param="actual_qty"
          type="Input"
          required="True"
          value={props.data.actual_qty}
        /> */}
        <DataField
          editMode={props.editMode}
          lg={8}
          md={24}
          handleChange={handleChange}
          name="CONTRACT REMARK"
          type="textarea"
          param="sauda_remark"
          value={props.data.sauda_remark}
        />
      </Row>
    </div>
  );
};

export default BasicDetail;
